
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/searchtips",
      function () {
        return require("private-next-pages/searchtips.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/searchtips"])
      });
    }
  